import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';

import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import * as organizationSelectors from '../../selectors/organizationSelectors';

import MenuItem from '../../components/MenuItem';
import routes from '../../helpers/OtherApplicationsPaths';
import ListItem from '@material-ui/core/ListItem';

class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    onToggle = () => {
        this.setState(state => ({ open: !state.open }));
    };

    onWebsiteClick = () => {
        window.open(routes.vizualist.website.getPath(), '_blank');
    };

    render() {
        const { organizations, selectedOrganizationId, classes } = this.props;
        const { open } = this.state;

        const listItems = organizations.map(organization => {
            return (
                <MenuItem
                    key={organization.id}
                    organization={organization}
                    selected={organization.id === selectedOrganizationId}
                    onClick={this.onToggle}
                />
            );
        });

        return (
            <React.Fragment>
                <IconButton onClick={this.onToggle}>
                    <i className="material-icons">menu</i>
                </IconButton>
                <Drawer
                    open={open}
                    onClose={this.onToggle}
                    classes={{ paper: classes.wrapper }}
                >
                    <div className={classes.header}>
                        <Typography variant="title" className={classes.title}>
                            <img alt="menu" src="/assets/dashboard.svg" />
                            Dashboard
                        </Typography>
                        <IconButton onClick={this.onToggle}>
                            <i className="material-icons">
                                keyboard_arrow_left
                            </i>
                        </IconButton>
                    </div>
                    <Divider />
                    <Typography className={classes.organizationsTitle}>
                        MY ORGANIZATIONS
                    </Typography>
                    <List>{listItems}</List>
                    <List className={classes.externalLinks}>
                        <Divider />
                        <ListItem className={classes.externalLink}>
                            <Typography noWrap>Website</Typography>

                            <IconButton onClick={this.onWebsiteClick}>
                                <img
                                    src="/assets/external_link_icon.svg"
                                    alt="website link"
                                />
                            </IconButton>
                        </ListItem>
                        <Divider />
                    </List>
                </Drawer>
            </React.Fragment>
        );
    }
}

Menu.propTypes = {
    organizations: PropTypes.array,
    selectedOrganizationId: PropTypes.number,
};

Menu.defaultProps = {
    organizations: [],
    selectedOrganizationId: undefined,
};

const mapStateToProps = state => ({
    organizations: organizationSelectors.getOrganizations(state),
    selectedOrganizationId: organizationSelectors.getCurrentOrganizationId(
        state,
    ),
});

const style = ({ spacing, menu, palette }) => ({
    wrapper: {
        width: menu.width,
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: [spacing.unit, spacing.unit * 2],
    },
    title: {
        marginLeft: spacing.unit,
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        '& img': {
            paddingRight: spacing.unit,
        },
    },
    organizationsTitle: {
        color: palette.text.gray,
        fontSize: '12px',
        margin: [
            spacing.unit * 4,
            spacing.unit * 2,
            spacing.unit,
            spacing.unit * 3,
        ],
    },
    externalLinks: {
        marginTop: 'auto',
        marginBottom: '128px',
    },
    externalLink: {
        display: 'flex',
        justifyContent: 'space-between',
        '& p': {
            fontWeight: '600',
        },
    },
});

export default connect(mapStateToProps)(injectSheet(style)(Menu));



// WEBPACK FOOTER //
// ./src/containers/menu/Menu.js